import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import RolesList from "../screens/masters/Roles/RolesList";

const breadCrumbData = [
  { link: "/masters-list", name: "Masters" },
  { link: "/roles-list", name: "Roles" }
];

const Home = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <RolesList />
    </LayoutContainer>
  </>
);

export default Home;
